'use strict';

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {find, on} from "../libs/@elements/dom-utils";

export function init () {
    onFind('.js-dateform__input', function (input) {
        on('change', function(event) {
            let button = find('.js-dateform__submit');
            button.removeAttribute('disabled');
        }, input);
    });
}